// extracted by mini-css-extract-plugin
export default {"colors_box":"colors-box_colors_box__03yxD","colors_grid":"colors-box_colors_grid__ex9hE","color_item":"colors-box_color_item__xc664","cat_color":"colors-box_cat_color__+lf25"};